import { render, staticRenderFns } from "./DivisionFilterSingle.vue?vue&type=template&id=319a531a"
import script from "./DivisionFilterSingle.vue?vue&type=script&lang=js"
export * from "./DivisionFilterSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports